import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import './OnboardingNav.css';

const OnboardingNav = () => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const user = authService.getCurrentUser();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      navigate('/login');
    }
  };

  return (
    <div className="onboarding-nav">
      <div className="onboarding-nav-content">
        <div className="onboarding-logo">
          <img
            src="/img/logo.png"
            alt="PELEEScribe"
            className="logo-img"
            onError={(e) => e.target.style.display = 'none'}
          />
          <span className="logo-text">PELEEScribe</span>
        </div>

        <div className="onboarding-nav-right">
          <div className="logout-section" ref={dropdownRef}>
            <button
              className="logout-btn"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              Logout
            </button>

            {isDropdownOpen && (
              <div className="logout-dropdown">
                <button
                  onClick={handleLogout}
                  className="logout-dropdown-btn"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 14H3.33A1.33 1.33 0 0 1 2 12.67V3.33A1.33 1.33 0 0 1 3.33 2H6M10.67 11.33 14 8l-3.33-3.33M14 8H6" stroke="#FF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingNav;
